import React from "react";
import { SiteThemeProvider } from "./SiteThemeProvider";

type GatsbyRootWrapperProps = {
  children: React.ReactElement;
  /** `browser` | `ssr` — used for debug markers only. */
  source: "browser" | "ssr";
};

/** Shared root wrapper for `gatsby-browser.js` and `gatsby-ssr.js`. */
export function GatsbyRootWrapper({ children, source }: GatsbyRootWrapperProps): React.JSX.Element {
  if (typeof document !== "undefined") {
    document.documentElement.dataset[`gatsbyWrapRoot${source === "browser" ? "Browser" : "Ssr"}`] = "1";
  }

  if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
    const label = `[theme] GatsbyRootWrapper (${source})`;
    if (typeof window !== "undefined") {
      console.log(label);
    } else {
      console.log(`${label} — SSR`);
    }
  }

  return <SiteThemeProvider>{children}</SiteThemeProvider>;
}
